import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../Store/AuthContext";
import axios from "axios";
import NotifyMessageNoReload from "../Others/NotifyMessageNoReload";
// import { useNavigate } from "react-router-dom";
import APIDataFetchLoader from "../Others/APIDataFetchLoader";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function PlanSubmitForm() {
  const { userID, RendomTokenfetch } = useAuth();
  // const navigate = useNavigate();

  const nameref = useRef("");
  const emailref = useRef("");
  const [description, setdescriptions] = useState("");

  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formSubmitLoader, setformSubmitLoader] = useState(false);

  //   Fetch categories on component mount
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    const FetchVendorcatData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}getallcategoryvendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setCategories(response.data.catdata || []);
            }
            if (response.data.Status === "0") {
              setCategories([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorcatData();
  }, [RendomTokenfetch, userID]);

  // Fetch services when category changes
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("catid", selectedCategory);
    const FetchVendorServiceData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}allcatservicevendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setServices(response.data.servicedata || []);
            }
            if (response.data.Status === "0") {
              setServices([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchVendorServiceData();
  }, [RendomTokenfetch, selectedCategory, userID]);

  const [mobileNumber, setMobileNumber] = useState("");

  const handleKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setMobileNumber(value);
      //   setWhatsappNumber(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setformSubmitLoader(true);
    let Verifydata = new FormData();
    Verifydata.append("name", nameref.current?.value || "");
    Verifydata.append("email", emailref.current?.value || "");
    Verifydata.append("number", mobileNumber);
    Verifydata.append("category_id", selectedCategory);
    Verifydata.append("service_id", selectedService);
    Verifydata.append("description", description);
    try {
      axios
        .post(`${WebsiteAPIurl}formleadadd`, Verifydata, {
          headers: {
            Authorization: RendomTokenfetch,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.Status === "1") {
            NotifyMessageNoReload(response.data.msg, "success", true);
            nameref.current.value = "";
            emailref.current.value = "";
            setMobileNumber("");
            setSelectedCategory("");
            setSelectedService("");
            setdescriptions("");
          } else {
            NotifyMessageNoReload(response.data.msg, "danger", true);
          }
        });
    } catch (error) {
      setError(error.message);
    } finally {
      setformSubmitLoader(false);
    }
  };

  if (loading) {
    // return <APIDataFetchLoader />;
  }
  if (formSubmitLoader) {
    return <APIDataFetchLoader />;
  }
  if (error) {
    alert(error);
  }

  return (
    <>
      <div className="PlanFormBox">
        {/* <h5>Book Service Now</h5> */}
        <p>Fill in the form below and we will be in touch soon</p>
        <form className="was-validated PlanSubmitForm" onSubmit={handleSubmit}>
          <div className="row">
            <div className="form-group col-lg-12 col-md-12 col-sm-12 mb-3">
              {/* <label htmlFor="name">Name</label> */}
              <input
                type="text"
                className="form-control"
                placeholder="Name"
                ref={nameref}
                defaultValue={""}
                required
              />
            </div>

            <div className="form-group col-lg-12 col-md-12 col-sm-12 mb-3">
              {/* <label>Mobile Number</label> */}
              <div className="input-group">
                <span className="input-group-text">+91</span>
                <input
                  type="text"
                  className="form-control"
                  name="mobileNumber"
                  placeholder="Number"
                  onChange={handleMobileChange}
                  onKeyPress={handleKeyPress}
                  value={mobileNumber}
                  maxLength={10}
                  inputMode="numeric"
                  required
                />
              </div>
            </div>

            <div className="form-group col-lg-12 col-md-12 col-sm-12 mb-3">
              {/* <label>Email</label> */}
              <div className="input-group">
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="Email"
                  ref={emailref}
                  defaultValue={""}
                />
              </div>
            </div>

            <div className="form-group col-lg-12 col-md-12 col-sm-12 mb-3">
              {/* <label>Category</label> */}
              <select
                className="form-control"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                required
              >
                <option value="">Service Category</option>
                {categories.map((val) => (
                  <option value={val.id} key={val.id}>
                    {val.category}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group col-lg-12 col-md-12 col-sm-12 mb-3">
              {/* <label>Service</label> */}
              <select
                className="form-control"
                value={selectedService}
                onChange={(e) => setSelectedService(e.target.value)}
                // disabled={!!selectedService}
                required
              >
                <option value="">Services</option>
                {services.map((value) => (
                  <option value={value.id} key={value.id}>
                    {value.title}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group col-lg-12 col-md-12 mb-3">
              {/* <label>Description</label> */}
              <textarea
                rows={2}
                className="form-control"
                placeholder="Massage"
                value={description}
                onChange={(e) => setdescriptions(e.target.value)}
              />
            </div>
          </div>

          <div className="col-lg-12 col-md-12  mt-3">
            <button className="col-lg-12 col-md-12 theme-btn btn-style-three submitbtn">
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
